import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOktaAuthContext } from '../contexts/OktaAuthContext.tsx';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoggedIn, isAuthPending } = useOktaAuthContext();

  if (isAuthPending) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
